import React from "react"
import DodonesResolverDay from "site/dodones_resolver/Day"
import { HashRouter } from 'react-router-dom'
import { Routes, Route } from 'react-router-dom'
import Menu from 'site/layout/Menu'

export default () => {
  return <HashRouter>
           <div className='frow'>
             <Menu />
             <div className="flex-1 p-d">
               <Routes>
                 <Route path="/" element={<DodonesResolverDay />} />
               </Routes>
             </div>
           </div>
         </HashRouter>
}
